const translit = function(input, spaceReplacement) {
  if (!input || typeof input !== "string") {
    return "";
  }
  if (!spaceReplacement) {
    spaceReplacement = "-";
  }
  const letters = {
    "а": "a",
    "б": "b",
    "в": "v",
    "г": "g",
    "д": "d",
    "е": "ye",
    "ё": "yo",
    "ж": "zh",
    "з": "z",
    "и": "i",
    "і": "i",
    "й": "y",
    "ї": "y",
    "к": "k",
    "л": "l",
    "м": "m",
    "н": "n",
    "о": "o",
    "п": "p",
    "р": "r",
    "с": "s",
    "т": "t",
    "у": "u",
    "ф": "f",
    "х": "kh",
    "ц": "ts",
    "ч": "ch",
    "ш": "sh",
    "щ": "shch",
    "ъ": "",
    "ы": "i",
    "ь": "",
    "э": "e",
    "ю": "yu",
    "я": "ya"
  };
  const normalizedInput = input.normalize();
  let newStr = "";
  for (let i = 0; i < normalizedInput.length; i++) {
    const strLowerCase = normalizedInput[i].toLowerCase();
    if (strLowerCase === " " || strLowerCase === spaceReplacement) {
      newStr += spaceReplacement || " ";
      continue;
    }
    const newLetter = letters[strLowerCase];
    if (typeof newLetter !== "undefined") {
      newStr += newLetter;
    } else if (strLowerCase.match(/[a-z]/i)) {
      newStr += strLowerCase;
    }
  }
  return newStr;
};
export {
  translit
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
